<form [formGroup]="connectionForm">
    <!-- Step 1: Setup SSO Domain -->
    <ng-container *ngIf="currentStep === 1">
        <div class="title" mat-dialog-title>Setup SSO Domain</div>
        <div class="dialog-body">
            <div class="body-content">
                <div class="form-text">Enter a domain prefix for your SSO configuration.</div>
                <div class="form-hint">(Domain is shared by all SSO platforms.)</div>
                <mat-form-field appearance="outline" class="form-field domain-field">
                    <mat-label>Domain Prefix</mat-label>
                    <input matInput placeholder="Enter domain prefix" formControlName="domainPrefix"
                        (blur)="validateDomainPrefix()" data-cy="google-sso-domain-prefix-input">
                    <span matSuffix class="domain-suffix">.{{domain}}</span>
                    <mat-error *ngIf="connectionForm.get('domainPrefix').hasError('required')">
                        Domain prefix is required
                    </mat-error>
                    <mat-error *ngIf="connectionForm.get('domainPrefix').hasError('pattern')">
                        Invalid domain prefix format
                    </mat-error>
                    <mat-error *ngIf="connectionForm.get('domainPrefix').hasError('unavailable')">
                        {{ domainErrorMessage }}
                    </mat-error>
                </mat-form-field>
                <div class="validation-status" *ngIf="isValidating">
                    <mat-spinner diameter="16"></mat-spinner>
                    <span>Checking availability...</span>
                </div>
                <div class="validation-status success" *ngIf="isDomainValid && !isValidating">
                    <mat-icon>check_circle</mat-icon>
                    <span>Domain is available</span>
                </div>
            </div>
        </div>
        <div class="dialog-footer">
            <div class="footer-buttons">
                <button mat-raised-button class="rubii-btn add-btn" color="primary"
                    [disabled]="!isDomainValid || isValidating" (click)="goToStep2()"
                    data-cy="google-sso-next-btn">Next</button>
            </div>
        </div>
    </ng-container>

    <!-- Step 2: Enter Email Domain -->
    <ng-container *ngIf="currentStep === 2">
        <div class="title" mat-dialog-title>Enter Email Domain</div>
        <div class="dialog-body">
            <div class="body-content">
                <div class="form-text">Enter the email domain for Google SSO login.</div>
                <mat-form-field appearance="outline" class="form-field">
                    <mat-label>Email Domain</mat-label>
                    <input matInput placeholder="example.com" formControlName="emailDomain"
                        data-cy="google-sso-mail-domain-input">
                    <mat-hint>Enter the email domain (the part after the "@" symbol)</mat-hint>
                    <mat-error
                        *ngIf="connectionForm.get('emailDomain').errors && (connectionForm.get('emailDomain').touched || connectionForm.get('emailDomain').dirty)">
                        Email domain is required
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="dialog-footer">
            <div class="footer-buttons">
                <button mat-stroked-button class="rubii-btn back-btn" (click)="goToStep1()"
                    data-cy="google-sso-back-btn">Back</button>
                <button mat-raised-button class="rubii-btn add-btn" color="primary" (click)="connect()"
                    data-cy="google-sso-connect-btn">Connect Data Source</button>
            </div>
        </div>
    </ng-container>
</form>
